import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "startSlot", "middleSlot"];
import { useEffect } from 'react';
import styled from 'styled-components';
import UIFilterBar from 'UIComponents/nav/UIFilterBar';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFilterBar = styled(UIFilterBar).withConfig({
  displayName: "MobileFilterBar__StyledFilterBar",
  componentId: "wodpwy-0"
})(["&&{padding-right:0 !important;}::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;"]);
const StyledMiddleSlot = styled(UIScrollContainer).withConfig({
  displayName: "MobileFilterBar__StyledMiddleSlot",
  componentId: "wodpwy-1"
})(["overflow:scroll;width:100%;.middleSlot{display:flex;> div{padding-right:10px;}}"]);
StyledFilterBar.displayName = 'StyledFilterBar';
export default function MobileFilterBar(_ref) {
  let {
      children,
      className,
      startSlot,
      middleSlot
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  useEffect(() => {
    if (children && startSlot) {
      console.warn('MobileFilterBar: children and startSlot cannot both be passed. Defaulting to startSlot');
    }
  }, [children, startSlot]);
  return /*#__PURE__*/_jsx(StyledFilterBar, Object.assign({}, props, {
    className: className,
    startSlot: startSlot
    // @ts-expect-error types incompatible?
    ,
    Middle: StyledMiddleSlot,
    middleSlot: /*#__PURE__*/_jsx("div", {
      className: "middleSlot",
      children: middleSlot
    }),
    responsive: false
  }));
}